import { render, staticRenderFns } from "./XmGoodsMark.vue?vue&type=template&id=0d90c432"
import script from "./XmGoodsMark.vue?vue&type=script&lang=js"
export * from "./XmGoodsMark.vue?vue&type=script&lang=js"
import style0 from "./XmGoodsMark.vue?vue&type=style&index=0&id=0d90c432&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports